import axios from 'axios';

export default {
    create(context, data) {
        var options = {
            url: window.apiUrl + '/mentor-category',
            method: 'POST',
            data: data,         
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    update(context, data) {
        var options = {
            url: window.apiUrl + '/mentor-category',
            method: 'PATCH',
            data: data,         
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    get(context,feed) {
        var options = {
            url: window.apiUrl + '/mentor-categories?feed='+feed,
            method: 'GET',
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    delete(context, id) {
        var options = {
            url: window.apiUrl + '/mentor-category/' + id,
            method: 'DELETE',            
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
}


// WEBPACK FOOTER //
// ./src/services/mentors/categories.js